/* Spirichill — stone reel + scroll reveals. Ported from prototype app.js. */
(function () {
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var save = navigator.connection && navigator.connection.saveData;
  var small = matchMedia('(max-width: 749px)').matches;

  // Stone reel: cycle clips one at a time, load each just in time.
  var reel = document.querySelector('[data-stone-reel]');
  if (reel && !rm && !save && !small) {
    var vids = Array.prototype.slice.call(reel.querySelectorAll('video'));
    if (vids.length) {
      var i = 0;
      var still = reel.querySelector('.sc-hero__still');
      vids[0].play().then(function () { if (still) still.style.opacity = 0; }).catch(function(){});
      var advance = function () {
        var cur = vids[i];
        i = (i + 1) % vids.length;
        var nxt = vids[i];
        try { nxt.currentTime = 0; } catch (e) {}
        nxt.play().catch(function(){});
        nxt.classList.add('is-active');
        cur.classList.remove('is-active');
        setTimeout(function(){ try { cur.pause(); } catch(e){} }, 1300);
        var after = vids[(i + 1) % vids.length];
        if (after.preload === 'none') { after.preload = 'auto'; after.load(); }
      };
      vids.forEach(function (v) { v.addEventListener('ended', advance); });
      setInterval(function () {
        var a = reel.querySelector('video.is-active');
        if (a && a.duration && a.currentTime >= a.duration - 0.35) advance();
      }, 400);
    }
  }

  // Scroll reveals
  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;
  if (rm || !('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (e) { io.observe(e); });
})();


/* ---------- PDP: size selection gates add-to-cart; thumbnail gallery ---------- */
(function(){
  var form = document.querySelector('.sc-pdp__form');
  if (form) {
    var atc  = form.querySelector('[data-atc]');
    var hint = form.querySelector('[data-size-hint]');
    form.addEventListener('change', function(e){
      if (e.target.name !== 'id') return;
      form.querySelectorAll('.sc-size').forEach(function(l){
        l.classList.toggle('is-on', l.contains(e.target));
      });
      if (atc)  { atc.disabled = false; atc.textContent = 'Add to Bag'; }
      if (hint) { hint.hidden = true; }
    });
    form.addEventListener('submit', function(e){
      if (!form.querySelector('input[name="id"]:checked')) {
        e.preventDefault();
        if (hint) { hint.hidden = false; hint.classList.add('is-warn'); }
      }
    });
  }
  var thumbs = document.querySelectorAll('.sc-pdp__thumb');
  var main   = document.querySelector('.sc-pdp__main .sc-ph__img');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      if (!main) return;
      main.src = t.dataset.src;
      main.removeAttribute('srcset');
      thumbs.forEach(function(x){ x.classList.remove('is-on'); });
      t.classList.add('is-on');
    });
  });
})();
